/* 2026-10-12 · Preventa: añade las propiedades de reserva a la línea del carrito
   cuando se compra desde un botón <add-to-cart data-reserve-state="preventa">. */
(function () {
  if (!window.fetch || window.__versoPreventa) return;
  window.__versoPreventa = true;
  var originalFetch = window.fetch;
  function reserveFor(id) {
    var el = document.querySelector('add-to-cart[data-variant-id="' + id + '"][data-reserve-state="preventa"]');
    return el ? (el.getAttribute('data-reserve-date') || '') : null;
  }
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string' && init.body.charAt(0) === '{') {
        var body = JSON.parse(init.body);
        var changed = false;
        (body.items || []).forEach(function (item) {
          var date = reserveFor(item.id);
          if (date !== null) {
            item.properties = Object.assign({}, item.properties, {
              'Preventa': 'Sí',
              'Publicación prevista': date || 'Pendiente de confirmar',
              'Envío': 'Pedido conjunto cuando todos los títulos estén disponibles'
            });
            changed = true;
          }
        });
        if (changed) init = Object.assign({}, init, { body: JSON.stringify(body) });
      }
    } catch (e) {}
    return originalFetch.call(this, input, init);
  };
})();
